// extracted by mini-css-extract-plugin
module.exports = {"container":"EcomtrackVsFbColumnHeader_container__1pljT"};